import apiClient from './client';
import { StoreBranding } from '../types/admin';

export const fetchStoreBranding = async (): Promise<StoreBranding> => {
  const { data } = await apiClient.get<StoreBranding>('/appmanage/branding');
  return data;
};

export interface UpdateStoreBrandingPayload {
  logoUrl: string;
  primaryColor: string;
  tagline: string;
  bannerUrl: string;
  notice: string;
}

export const updateStoreBranding = async (payload: UpdateStoreBrandingPayload): Promise<void> => {
  await apiClient.put('/appmanage/branding', payload);
};
